import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["countdown", "zoomButton", "timer"]
  static values = {
    scheduledAt: String,
    endAt: String,
    zoomLink: String
  }

  connect() {
    this.update()
    this.interval = setInterval(() => this.update(), 1000)
  }

  disconnect() {
    if (this.interval) {
      clearInterval(this.interval)
    }
  }

  update() {
    const now = new Date()
    const scheduledAt = new Date(this.scheduledAtValue)
    const endAt = new Date(this.endAtValue)
    const zoomWindowStart = new Date(scheduledAt.getTime() - 15 * 60 * 1000)

    if (now >= endAt) {
      this.showEnded()
      return
    }

    if (now >= scheduledAt) {
      this.showInProgress()
      this.showZoomButton()
      return
    }

    if (now >= zoomWindowStart) {
      this.showZoomButton()
    } else {
      this.hideZoomButton()
    }

    this.showCountdown(scheduledAt - now)
  }

  showCountdown(milliseconds) {
    const seconds = Math.floor(milliseconds / 1000)
    const minutes = Math.floor(seconds / 60)
    const hours = Math.floor(minutes / 60)
    const days = Math.floor(hours / 24)

    let display = ""

    if (days > 0) {
      display += `${days}d `
    }
    if (hours % 24 > 0 || days > 0) {
      display += `${hours % 24}h `
    }
    if (minutes % 60 > 0 || hours > 0) {
      display += `${minutes % 60}m `
    }
    display += `${seconds % 60}s`

    if (this.hasCountdownTarget) {
      this.countdownTarget.textContent = display
    }
  }

  showInProgress() {
    if (this.hasCountdownTarget) {
      this.countdownTarget.textContent = "In Progress"
      this.countdownTarget.classList.add("text-green-600")
    }
  }

  showEnded() {
    if (this.hasCountdownTarget) {
      this.countdownTarget.textContent = "Session Ended"
      this.countdownTarget.classList.add("text-beige-500")
    }
    this.hideZoomButton()
    clearInterval(this.interval)
  }

  showZoomButton() {
    if (this.hasZoomButtonTarget && this.zoomLinkValue) {
      this.zoomButtonTarget.classList.remove("hidden")
    }
  }

  hideZoomButton() {
    if (this.hasZoomButtonTarget) {
      this.zoomButtonTarget.classList.add("hidden")
    }
  }
}
